import { SpecificDays } from './types';

export const ALL_DAY: SpecificDays[] = [];

export const MONTHS = [
  'Январь',
  'Февараль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];
